// @ts-strict-ignore
import { FsCore } from '../../types/fs-core'

export const productTablesState = (s: FsCore.State) => s.productTables

export const tableState = (s: FsCore.State, key: string) => productTablesState(s)[key] || {}

export const getSorts = (s: FsCore.State, key: string) => tableState(s, key).sorts || {}

export const getPageOffset = (s: FsCore.State, key: string) => tableState(s, key).pageOffset

export const getMaxPerPage = (s: FsCore.State, key: string) => tableState(s, key).maxPerPage

export const getErrors = (s: FsCore.State, key: string) => tableState(s, key).errors

export const getEligibilityExpired = (s: FsCore.State, key: string) =>
  !!tableState(s, key).eligibilityResults?.expired

export const getEligibilityProviderTimeout = (s: FsCore.State, key: string) =>
  !!tableState(s, key).eligibilityResults?.providerTimeout

export const getNoEligibilityResults = (s: FsCore.State, key: string) =>
  !!tableState(s, key).eligibilityResults?.noEligibilityResults
